module.exports = __webpack_public_path__ + "static/media/oracle_logo.7f720011.png";